import dynamic from 'next/dynamic'
import { Box, Typography } from '@mui/material'

// Types
import type { SectionHeadingProps } from '@/types/components/molecules/solution'

// Components
const EyebrowTypographyAtom = dynamic(() => import('@/components/atoms/typography/eyebrow'))

// Eyebrow label, title and optional subtitle at the top of a page section
const SectionHeadingMolecule = (props: SectionHeadingProps) => {
	// Props
	const { eyebrow, title, subtitle, align = 'center', inverted } = props

	return (
		<Box sx={{ textAlign: align, maxWidth: align === 'center' ? 760 : 'none', mx: align === 'center' ? 'auto' : 0 }}>
			{eyebrow && <EyebrowTypographyAtom text={eyebrow} />}

			<Typography
				component="h2"
				sx={{
					mt: eyebrow ? 2 : 0,
					fontSize: { xs: 24, md: 28 },
					fontWeight: 500,
					lineHeight: 1.35,
					color: inverted ? 'common.white' : 'text.primary'
				}}
			>
				{title}
			</Typography>

			{subtitle && <Typography sx={{ mt: 2, fontSize: { xs: 16, md: 17 }, lineHeight: 1.9, color: inverted ? 'grey.300' : 'text.secondary' }}>{subtitle}</Typography>}
		</Box>
	)
}

export default SectionHeadingMolecule
